import naja from "naja";
import Sortable from 'sortablejs';

document.addEventListener('DOMContentLoaded', () => {

    init();
    naja.addEventListener('complete', () => {
        init();
    });

    function init() {
        const columnOrder = new ColumnOrder();
        columnOrder.init();

        const saveOrderButton = document.getElementById('saveOrder');
        if (saveOrderButton) {
            saveOrderButton.onclick = (e) => {
                const columns = Array.from(document.querySelectorAll('#draggable-columns .draggable-item'))
                    .map(item => item.dataset.column);
                const saveOrderUrl = saveOrderButton.getAttribute('data-save-order-url');
                naja.makeRequest('POST', saveOrderUrl, {
                    columns: columns
                }, { history: false });
            };
        }
    }

    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('draggable-item')) {
            e.target.classList.toggle('selected');
        }
    });

});

class ColumnOrder {
    init() {
        this.initSortableRows();
        this.initTransferButtons();
        this.initBulkTransferButtons();
    }

    initSortableRows() {
        this.initSortable(document.querySelector("#draggable-columns"));
    }

    initSortable(element) {
        if (element) {
            Sortable.create(element, {
                animation: 150,
                onEnd: (evt) => {
                    this.handleSortEnd(evt);
                },
            });
        }
    }

    handleSortEnd(evt) {
        const order = Array.from(evt.to.children).map(child => child.dataset.column);
        console.log('New order:', order);
    }

    initTransferButtons() {
        const moveToActiveElem = document.getElementById('moveToActive');
        if (moveToActiveElem) {
            moveToActiveElem.onclick = () => {
                this.moveSelectedItems('#available-columns', '#draggable-columns');
            };
        }

        const moveToAvailableElem = document.getElementById('moveToAvailable');
        if (moveToAvailableElem) {
            moveToAvailableElem.onclick = () => {
                this.moveSelectedItems('#draggable-columns', '#available-columns');
            };
        }
    }

    initBulkTransferButtons() {
        const removeAllButton = document.getElementById('removeAll');
        if (removeAllButton) {
            removeAllButton.onclick = () => {
                this.moveAllItems('#draggable-columns', '#available-columns');
            };
        }


        const addAllButton = document.getElementById('addAll');
        if (addAllButton) {
            addAllButton.onclick = () => {
                this.moveAllItems('#available-columns', '#draggable-columns');
            };
        }

    }

    moveSelectedItems(fromSelector, toSelector) {
        const from = document.querySelector(fromSelector);
        const to = document.querySelector(toSelector);
        const selectedItems = from.querySelectorAll('.selected');

        selectedItems.forEach(item => {
            item.classList.remove('selected');
            to.appendChild(item);
        });
    }

    moveAllItems(fromSelector, toSelector) {
        const from = document.querySelector(fromSelector);
        const to = document.querySelector(toSelector);
        const allItems = from.querySelectorAll('.draggable-item');

        allItems.forEach(item => {
            item.classList.remove('selected');
            to.appendChild(item);
        });
    }
}

export default ColumnOrder;
